import axiosAuthInstance from '../utils/getSubdomain'

export type GenerationJobStatus =
  | 'queued'
  | 'processing'
  | 'completed'
  | 'partially_completed'
  | 'failed'
  | 'cancelled'

export type GenerationSlot = {
  slot_key: string
  topic: string
  subtopic: string
  number_of_questions: number
  status: GenerationJobStatus
  error?: string | null
  warning?: string | null
  imported_question_ids: string[]
  imported_result_ids: string[]
  progress_percentage?: number
  current_stage?: string | null
}

export type QuestionGenerationJob = {
  id: string
  template_id: string
  template_name: string
  subject_title: string
  grade: string
  status: GenerationJobStatus
  requested_count: number
  imported_count: number
  failed_count: number
  slots: GenerationSlot[]
  created_at?: string
  updated_at?: string
  completed_at?: string | null
}

type ApiEnvelope<T> = {
  success: boolean
  status_code: number
  message: string
  data: T
}

export const generateQuestionsFromTemplate = (templateId: string) =>
  axiosAuthInstance.post<ApiEnvelope<QuestionGenerationJob>>(
    '/question-generation/from-template',
    { template_id: templateId }
  )

export const getGenerationJob = (jobId: string) =>
  axiosAuthInstance.get<ApiEnvelope<QuestionGenerationJob>>(
    `/question-generation/jobs/${jobId}`
  )

export const listGenerationJobs = (templateId?: string) =>
  axiosAuthInstance.get<ApiEnvelope<QuestionGenerationJob[]>>(
    '/question-generation/jobs',
    { params: templateId ? { template_id: templateId } : undefined }
  )

export const isTerminalGenerationStatus = (status?: GenerationJobStatus) =>
  status === 'completed' ||
  status === 'partially_completed' ||
  status === 'failed' ||
  status === 'cancelled'
